export const SERVICE_BOOKING_FORM_DATA_ID = 'react-data-service-order-booking-form'
export const FORM_FIELD_ID_PREFIX = 'o-service-order-booking-form_';
export const CSS_FONT_SAIRA = "Saira";
export const CSS_FONT_INTER = "Inter";
